import lodash from 'lodash';
import { useContext } from 'react';

import { ModalServiceContext, RicosContext } from './../../ricos-context';

import { TABLE_COLOR_PICKER } from '../consts';
import type { TableColorPickerProps } from './TableColorPicker';

export const useColorPickerModal = () => {
  const { isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);

  const toggleModal = (
    referenceElement: HTMLElement | null,
    { color, onChange }: Pick<TableColorPickerProps, 'color' | 'onChange'>
  ) => {
    if (isModalOpen()) {
      return closeModal();
    }

    const componentProps: TableColorPickerProps = {
      color,
      onChange,
      referenceElement,
    };

    return modalService.openRegisteredModal(TABLE_COLOR_PICKER, {
      positioning: { placement: 'bottom', referenceElement },
      layout: isMobile ? 'drawer' : 'toolbar',
      noPadding: true,
      onClickOutside: lodash.noop,
      componentProps,
    });
  };

  const closeModal = () => modalService.closeModal(TABLE_COLOR_PICKER);

  const isModalOpen = () => modalService.isModalOpen(TABLE_COLOR_PICKER);

  return { toggleModal, isModalOpen };
};
